/**
 * add-user-dialog.js
 */

import React from 'react';
import {
  Typography,
  TextField,
} from '@mui/material';
import { Alert } from '@mui/material';
import { Types } from 'utils/constants';
import Dialog from 'components/dialog';


export default function AddUserDialog(props) {
  const {
    isOpen,
    onOk,
    onClose,
    managerRole,
    error,
  } = props;
  const [userEmail, setUserEmail] = React.useState('');
  const inputRef = React.useRef();


  React.useEffect(() => {
    if (isOpen) {
      setUserEmail('');
      setTimeout(() => inputRef.current?.focus());
    }
  }, [isOpen]);


  return (
    <Dialog
      title={`Add Managed ${managerRole === Types.Role.SUPERVISOR || managerRole === Types.Role.TRAINER 
        ? 'Handler' 
        : 'Supervisor'}`}
      titleIcon={`${managerRole === Types.Role.SUPERVISOR || managerRole === Types.Role.TRAINER 
        ? 'handler' 
        : 'supervisor'}`}
      maxWidth='xs'
      fullWidth
      open={isOpen}
      onOk={() => onOk(userEmail, managerRole)}
      onClose={onClose}
    >
      <div style={{ margin: '12px 0' }} />

      {managerRole === Types.Role.SUPERVISOR &&
      <Typography paragraph={true}>
        Invite a handler that you wish to supervise. A handler who accepts this request gives you permission to view their training and deployment records.
        <br /><br />
        Note that the handler must be a PACKTRACK member. If they're not, then first ask them to sign up for an account at packtrackapp.com. You may also create their account yourself using the Signup New Member option available in the +Member button above. A 30 day free trial option is available for new handlers to get started.
      </Typography>}

      {managerRole === Types.Role.MANAGER &&
      <Typography paragraph={true}>
        Invite other supervisors to share their handler records with you. A supervisor who accepts this request gives you access to all of their handler records for training and deployment. This includes handlers that they supervise directly as well as any handlers that are visible to them because they invited another supervisor.
        <br /><br />
        Note that the supervisor must be a PACKTRACK member. If they're not, then first ask them to sign up for an account at packtrackapp.com. Supervisor accounts are completely free.
      </Typography>}

      {managerRole === Types.Role.TRAINER &&
      <Typography paragraph={true}>
        Invite a handler that you wish to train. A handler who accepts this request gives you permission to view their records and create new events and exercises for them.
        <br /><br />
        Note that the handler must be a PACKTRACK member. If they're not, then first ask them to sign up for an account at packtrackapp.com. A 30 day free trial option is available for new handlers to get started.
      </Typography>}
      
      {error &&
      <Alert severity='error'style={{ marginTop: 16 }}>{error}</Alert>}

      <TextField
        variant='outlined'
        fullWidth
        label='Email'
        inputRef={inputRef}
        value={userEmail}
        style={{ marginTop: 16 }}
        inputProps={{ 'data-testid': 'invite-email-input' }}
        onChange={e => setUserEmail(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onOk(userEmail, managerRole)
          }
        }}
      />
    </Dialog>
  );
}